import { createContext } from 'react';
import type { EntitlementsRead, PlanFeature, PlanLimitKey } from '../../types/api';

export interface PlanContextValue {
  /**
   * What the account's plan allows, or null while it loads and whenever the
   * lookup failed. Null is "unknown", never "Free": nothing is hidden or
   * disabled on an unknown plan. The backend enforces every gate with a 402
   * whatever the client believes, the way it enforces the quota with a 429.
   */
  entitlements: EntitlementsRead | null;
  /** True while the first read for this account is in flight. */
  loading: boolean;
  /** Re-reads the entitlements. */
  refresh: () => void;
  /**
   * Whether the plan includes `feature`. True while unknown, so a failed read
   * never locks the user out of something they paid for.
   */
  can: (feature: PlanFeature) => boolean;
  /**
   * The plan's cap for `key`: a number, `null` for unlimited, or `undefined`
   * while the plan is unknown. Callers must not treat `undefined` as a cap.
   */
  limit: (key: PlanLimitKey) => number | null | undefined;
}

/**
 * The account's plan context, mounted in `AppLayout` beside `QuotaContext` so
 * the settings Plan card, the gates and (later) the upsell read one reading.
 *
 * In `src/components/` for the same reason as the quota: it is shell state
 * that several features read, not one feature's.
 */
export const PlanContext = createContext<PlanContextValue | null>(null);
